import { Component } from '@angular/core';

@Component({
  selector: 'app-barcode',
  template: `
    <div class="text-center">
      <h3 class="text-center">Barcode Scanner</h3>
      <p>User Instant Search or Alternatively you can upload your barcode or scan via webcam/camera</p>
      <div class="flex-container" fxLayout="row" fxLayoutAlign="center center">
        <div class="flex-item" [routerLink]="['field']">
          <button mat-fab>
            <h6>file_upload</h6>
          </button>
        </div>
        <div class="flex-item" [routerLink]="['media']">
          <button mat-fab>
            <h6>camera</h6>
          </button>
        </div>
      </div>
    </div>
    
    <div>
      <router-outlet></router-outlet>
    </div>
  `,
  styleUrls: ['./barcode.component.scss']
})
export class BarcodeComponent {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/barcode/barcode.component.ts